// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { FlaskConical as RawFlaskConical } from "lucide-react";
export const FlaskConical = /* @__PURE__ */ createIcon(RawFlaskConical, "FlaskConical", 2);
